import styled, { keyframes } from 'styled-components';

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RadioWrapper = styled.div`
  border: 2px solid var(--secondary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: relative;

  &.primary {
    border-color: var(--primary);

    &::before {
      background: var(--primary);
    }
  }

  &::before {
    position: absolute;
    content: '';

    inset: 0;
    margin: auto;

    width: 0;
    height: 0;
    background: var(--secondary);
    border-radius: 50%;
    transition: 0.1s ease-out;
  }

  &.checked::before {
    width: 0;
    height: 0;

    width: 8px;
    height: 8px;
  }
`;

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const CustomLoadingOutlined = styled.div`
  border-radius: 100%;
  border: 1px solid var(--gray);
  border-right-color: transparent;
  animation: ${rotate} 1s infinite linear;
`;
